<script lang="ts">
    import { embedCheckout } from "@bigcommerce/checkout-sdk"
    import { onMount } from "svelte"
    import { location } from "../lib/store"

    onMount(() => {
        const url = decodeURIComponent($location.search.split("checkoutURL=")[1])
        console.log("test", "foo-bar-checkout", url)
        embedCheckout({
            containerId: "checkout-app",
            url,
            onError: (error) => {
                console.error(error)
            },
            onFrameError: (error) => {
                console.error(error)
            },
            onFrameLoad: (e) => {
                console.log("Frame loaded", e)
            },
        })
    })

    /*Content-Security-Policy default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval' https://cdn11.bigcommerce.com https://api.goaffpro.com; style-src 'self' 'unsafe-inline' https://fonts.googleapis.com https://cdn11.bigcommerce.com; font-src 'self' https://fonts.gstatic.com https://cdn11.bigcommerce.com; img-src 'self' https://cdn11.bigcommerce.com data:; connect-src 'self' https://api.bigcommerce.com https://bkdf-tibiserver.code.testversion.online https://cdn11.bigcommerce.com https://sentry.io; frame-ancestors 'self' https://bin-krass-du-fass.mybigcommerce.com/ https://bkdf.code.testversion.online;*/
    /*xframe: https://bkdf.code.testversion.online*/
</script>

<div id="checkout-app"></div>

<style lang="less">
</style>
